import * as React from 'react';
import { InlineText2, ModalWindow } from '@cian/ui-kit';
import { Footer, Content } from './inner';
import { IDiscountNewBuildings } from '../../types/developer/discounts';

interface IPromoDescriptionModalProps {
  name: string;
  open: boolean;
  dueDate: string | null;
  description: string | null;
  authorName: string | null;
  authorLogoUrl: string;
  authorLabel: string;
  onClose(): void;
  newBuildings: IDiscountNewBuildings[];
  callback: React.ReactNode;
}

export const PromoDescriptionModal = ({
  callback,
  open,
  name,
  description,
  newBuildings,
  authorLabel,
  authorLogoUrl,
  authorName,
  dueDate,
  onClose,
}: IPromoDescriptionModalProps) => {
  return (
    <ModalWindow
      open={open}
      content={<Content description={description} newBuildings={newBuildings} />}
      escape
      fixed={false}
      footer={
        <Footer authorLabel={authorLabel} authorName={authorName} authorLogoUrl={authorLogoUrl} callback={callback} />
      }
      header={<InlineText2 color="gray60_100">{dueDate}</InlineText2>}
      maxWidth={728}
      onClose={onClose}
      outside
      size="M"
      title={name}
    />
  );
};

PromoDescriptionModal.displayName = 'PromoDescriptionModal';
